import React, { useEffect, useState } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import { Card } from "antd";
import { isClassificationsServer } from "../../page/utils";
import { Redirect } from "react-router-dom";
import { MARGIN_MD, MARGIN_SM, PADDING_MD } from "../../styles/constants";
import { withSize } from "react-sizeme";
import axios from "axios";

const HOME_PAGE_PATH = "static/homepage/";

const mapStateToProps = (state) => ({
  anonymousPages: state.config.userInterface.anonymousPages,
  language: state.app.language,
  languages: state.config.userInterface.languages,
  username: state.app.user.username,
  permissions: state.app.user.permissions,
});

const Home = ({
  t,
  username,
  language,
  languages,
  permissions,
  anonymousPages,
}) => {
  const [homePageCache, setHomePageCache] = useState({});
  const [homePage, setHomePage] = useState("");

  useEffect(
    () => {
      const currUrl = window.location;
      const baseUrl = currUrl.protocol + "//" + currUrl.host + currUrl.pathname;

      // fileUrl returns a string denoting the url of the language file of the home according the to supplied language code as a parameter
      const fileUrl = (language) =>
        `${baseUrl}${
          baseUrl.slice(-1) === "/" ? "" : "/"
        }${HOME_PAGE_PATH}${language}.html`;

      // this function is a fallback on inexistant language file, it tries with the rest of the available languages, otherwise does nothing
      const fallBack = async () => {
        for (let i = 0; i < languages.length; i++) {
          try {
            const language = languages[i].code;
            if (language in homePageCache) {
              setHomePage(homePageCache[language]);
            } else {
              let response = await axios.get(fileUrl(language));
              if (response.status === 200) {
                setHomePageCache({
                  ...homePageCache,
                  [language]: response.data,
                });
                setHomePage(response.data);
                break;
              }
            }
          } catch (e) {
            continue;
          }
        }
      };
      if (language) {
        if (language in homePageCache) {
          // Check if the homepage in the selected language is already fetched
          setHomePage(homePageCache[language]);
        } else {
          // Setting the homepage file according to language of the tool, otherwise it fallback to another language .
          axios
            .get(fileUrl(language))
            .then((res) => {
              setHomePageCache({
                ...homePageCache,
                [language]: res.data,
              });
              setHomePage(res.data);
            })
            .catch(function(err) {
              fallBack();
            });
        }
      } 
      
    },
    [language]
  );

  return isClassificationsServer(username, permissions, anonymousPages, t) ? (
    <Redirect to={anonymousPages[0]} />
  ) : homePage ? (
    <Card
      className="home"
      style={{ marginTop: MARGIN_MD, marginBottom: MARGIN_SM, width: "100%" }}
      bodyStyle={{ padding: PADDING_MD }}
    >
      <iframe
        title={"homePageIframeTitle"}
        id={"homePageIframeId"}
        srcDoc={homePage}
        style={{ border: 0, width: "100%" }}
      />
    </Card>
  ) : (
    <div />
  );
};

export default compose(
  connect(mapStateToProps),
  translate(),
  withSize()
)(Home);
